<template>
  <li class="nav-item dropdown dropdown-notification">
    <a
      role="button"
      href="#"
      target="_self"
      data-toggle="dropdown"
      class="nav-link dropdown-toggle"
      aria-expanded="false"
      id="__BVID__105__BV_toggle_"
    >
      <span class="feather-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.3419 14.49L18.3419 12.83C18.1319 12.46 17.9419 11.76 17.9419 11.35V8.82C17.9419 6.47 16.5619 4.44 14.5719 3.49C14.0519 2.57 13.0919 2 11.9919 2C10.9019 2 9.9219 2.59 9.4019 3.52C7.4519 4.49 6.1019 6.5 6.1019 8.82V11.35C6.1019 11.76 5.9119 12.46 5.7019 12.82L4.6919 14.49C4.2919 15.16 4.2019 15.9 4.4519 16.58C4.6919 17.25 5.2619 17.77 6.0019 18.02C7.9419 18.68 9.9819 19 12.0219 19C14.0619 19 16.1019 18.68 18.0419 18.03C18.7419 17.8 19.2819 17.27 19.5419 16.58C19.8019 15.89 19.7319 15.13 19.3419 14.49Z"
            fill="#2463EB"
          />
          <path
            d="M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z"
            fill="#2463EB"
          />
        </svg>

        <span class="badge badge-up badge-pill bg-danger">{{
          notificationCount
        }}</span>
      </span>
    </a>
    <ul
      tabindex="-1"
      class="dropdown-menu dropdown-menu-media dropdown-menu-right notif-dropdown bg-[#fcfcfd] max-w-[450px] w-full"
      aria-labelledby="__BVID__105__BV_toggle_"
    >
      <li>
        <div class="dropdown-header d-flex">
          <h4
            class="font-bold text-[16px] leading-[24px] capitalize text-[#353535] pb-[16px]"
          >
            Notifications
          </h4>
        </div>
      </li>
      <li class="px-1">
        <div v-for="notification in notifications" :key="notification.id">
          <div
            class="notif-hover d-inline"
            @click="readNotification(notification.id)"
          >
            <p
              class="font-medium text-[14px] leading-[20px] text-[#000000] mb-[8px]"
            >
              {{ notification.title }}
            </p>
            <p
              class="text-[14px] leading-[20px] font-normal text-[#353535] mb-[8px]"
              v-html="returnSpan(notification)"
            />
            <p class="text-[#96A0B5] text-12px font-medium leading-[20px]">
              {{ days(notification) }}
            </p>
          </div>
          <hr class="my-[8px]" />
        </div>

        <div v-if="notifications.length <= 0" class="media">
          <div class="media-body d-flex justify-content-center pb-[16px]">
            <span>
              <i class="mdi mdi-email-open" />
              You're up to date.</span
            >
          </div>
        </div>
        <div class="media pt-[10px]">
          <div class="media-body d-flex justify-content-center">
            <router-link to="/notifications" class="btn btn-text mb-1"
              ><span class="text-[#2463EB] text-[14px] font-normal"
                >View All Notifications</span
              ></router-link
            >
          </div>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
import moment from "moment";
import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";

const url = process.env.VUE_APP_BASE_API_URL;

export default {
  name: "notification",
  props: ["parentId"],
  data() {
    return {
      notifications: [],
    };
  },

  watch: {
    parentId: "getNotifications",
  },

  mounted: function() {
    this.getUnreadCount();
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    notificationCount: function() {
      return this.$store.state.notificationCount;
    },
  },

  updated() {
    if (this.$auth.getToken()) {
      let connection = new HubConnectionBuilder()
        .withUrl(`${url}/hubs/notifications`, {
          accessTokenFactory: () => this.$auth.getToken(),
        })
        .configureLogging(LogLevel.None)
        .build();

      connection.on("displayNotification", (notification) => {
        this.$toast.info(notification.title, {
          icon: true,
          rtl: false,
        });
        this.notifications.unshift(notification);
      });
      Object.defineProperty(WebSocket, "OPEN", { value: 1 });
      connection.start();
    }
  },

  methods: {
    returnSpan(notif) {
      let secondaryArr = notif.secondary ? notif.secondary.split("*") : [];

      let newStatementRep = "";

      newStatementRep = notif.statement.replace(
        "[FocalPoint]",
        `<span class='font-normal text-[#2463EB]'> ${notif.focalPoint} </span>`
      );

      for (let i = 0; i < secondaryArr.length; i++) {
        newStatementRep = newStatementRep.replace(
          `[${i}]`,
          `<span class='font-weight-bold'> ${secondaryArr[i]} </span>`
        );
      }
      return `<span> ${newStatementRep} </span>`;
    },

    goToUrl(url) {
      if (url !== "") {
        this.$router.push(`${url}`);
      }
    },

    days(notif) {
      const days = moment(new Date()).diff(notif.date, "days");
      return days > 0 ? `${days} day${days > 1 ? "s" : ""} ago` : "Today";
    },

    async getNotifications() {
      const response = await this.$http.get(
        "/Notification?read=false&pageSize=4"
      );
      this.notifications = response.body.data;
    },

    async getUnreadCount() {
      const response = await this.$http.get("/Notification/count?isRead=false");
      this.$store.commit("setNotificationCount", response.body);
    },

    async submitRead(id) {
      let body = {
        ids: [id].toString(),
      };
      const response = await this.$http.put("/Notification/read", body);
      if (response.body) {
        this.getNotifications();
        this.getUnreadCount();
      }
    },

    async markAllAsRead() {
      let selectedIds = [];
      for (var i = 0; i < this.notifications.length; i++) {
        selectedIds.push(this.notifications[i].id);
      }

      let body = {
        ids: selectedIds.toString(),
      };

      await this.$http
        .put("/notification/read", body)
        .then(function(res) {
          this.getNotifications();
          this.getUnreadCount();
        })
        .catch(function() {});
    },

    readNotification(id) {
      this.submitRead(id);
      const notificationIndex = this.notifications.findIndex(
        (x) => x.id === id
      );
      this.notifications[notificationIndex].read = true;
    },

    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },
  },
};
</script>

<style scoped>
.notif-dropdown {
  height: auto !important;
  min-width: 350px;
}

.dropdown .dropdown-menu.dropdown-menu-right::before {
  right: 5.8rem;
  left: auto;
}

.notif-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: greenyellow;
}

.title-text {
  font-size: 15px;
  margin-bottom: 0px !important;
}

.notif-body {
  font-size: 12px;
  margin-bottom: 5px !important;
}

@media only screen and (min-width: 768px) {
  .notif-dropdown {
    height: auto !important;
    min-width: 450px;
    position: absolute !important;
    right: -200px !important;
  }

  .dropdown .dropdown-menu.dropdown-menu-right::before {
    right: 14.6rem;
    left: auto;
  }
}
</style>
